import { Button, Col, Container, Row } from "react-bootstrap";
import { FaInstagram } from "react-icons/fa";

const previewItems = [
  {
    category: "Vida escolar",
    title: "Momentos compartidos",
    text: "Actividades, encuentros y proyectos que forman parte de nuestra comunidad.",
  },
  {
    category: "Niveles",
    title: "Aprendizajes en acción",
    text: "Propuestas de Inicial, Primario y Secundario durante el ciclo lectivo.",
  },
  {
    category: "Comunidad",
    title: "Celebraciones y valores",
    text: "Fe, participación y compromiso en las experiencias del colegio.",
  },
];

function InstagramPreview() {
  // TODO: Conectar esta preview con la API real de Instagram cuando este disponible.
  return (
    <section className="home-instagram-section" aria-labelledby="instagram-preview-title">
      <Container>
        <div className="home-section-heading">
          <span>Redes institucionales</span>
          <h2 id="instagram-preview-title">Seguinos en Instagram</h2>
        </div>

        <div className="home-instagram-card">
          <div className="home-instagram-profile">
            <div className="home-instagram-icon" aria-hidden="true">
              <FaInstagram />
            </div>
            <div>
              <p className="home-instagram-label">Colegio Santo Tomás</p>
              <p className="home-instagram-handle">@santotomassr</p>
            </div>
            <Button
              className="home-instagram-button"
              href="https://www.instagram.com/santotomassr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ver Instagram
            </Button>
          </div>

          <Row className="g-3">
            {previewItems.map((item) => (
              <Col xs={12} md={4} key={item.title}>
                <article className="home-instagram-post">
                  <span>{item.category}</span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default InstagramPreview;
